module.exports = __webpack_public_path__ + "static/Kettleandfire-color-9ead6f2066e9c09c13d3a893f80a6f2d.svg";